import { Vehicle } from '@agilox/common';
import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { mergeMap, switchMap } from 'rxjs';
import { AppSettings } from '../../general/interfaces/app-settings.interface';
import { AppsettingsService } from '../../general/shared/services/appsettings/appsettings.service';
import { setMode } from '../mode-filter/mode-filter.actions';
import { reloadVehicles } from '../vehicles/vehicles.actions';
import { saveMultipleVehicles, setVehicles } from './vehicle-filter.actions';

@Injectable()
export class VehicleFilterEffects {
	constructor(
		private actions$: Actions,
		private appSettingsService: AppsettingsService
	) {}

	saveMultipleSelectedVehicles$ = createEffect(
		() =>
			this.actions$.pipe(
				ofType(saveMultipleVehicles),
				switchMap((action: { value: Vehicle[] }) => {
					return this.appSettingsService
						.saveVehiclesAndMode(action.value.map((v) => v.serial))
						.pipe(
							mergeMap((filter: AppSettings) => [
								setVehicles({ value: action.value }),
								setMode({ value: filter.dateSelector.mode }),
								reloadVehicles({ value: filter.selectedMachines }),
							])
						);
				})
			),
		{ dispatch: true }
	);
}
